import React, { useState, useContext } from 'react';
import './object.css';
import { validateSteps } from "../validateSteps";
import { LanguageContext } from "../context/LanguageContext";

const CreateObjectStep5 = ({
  formData,
  setFormData,
  onNext,
  onBack,
  missingFields = [],
  setMissingFields,
  validationActive
}) => {

  const { texts } = useContext(LanguageContext);

  const descriptionPlaceholder = texts.object.step5.descriptionPlaceholder;

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updated = { ...formData, [name]: value };
    setFormData(updated);

    if (validationActive) {
      const { missing } = validateSteps(updated);
      setMissingFields(missing);
    }
  };

  const handleDescriptionFocus = () => {
    if (formData.description === descriptionPlaceholder) {
      const updated = { ...formData, description: '' };
      setFormData(updated);

      if (validationActive) {
        const { missing } = validateSteps(updated);
        setMissingFields(missing);
      }
    }
  };

  const handleDescriptionBlur = () => {
    if (!formData.description) {
      const updated = { ...formData, description: descriptionPlaceholder };
      setFormData(updated);

      if (validationActive) {
        const { missing } = validateSteps(updated);
        setMissingFields(missing);
      }
    }
  };

  return (
    <div className="object-form-container">
      <h2 className="object-header">{texts.object.step5.title}</h2>

      <div className="object-content-scroll-area">
        <div className="form-cards">

          <form className="object-form">

            {/* Aktivitäten in der Nähe */}
            <div className="form-text-activitys">
              <h4 className="object-title">{texts.object.step5.activitiesTitle}</h4>
              <textarea
                id="activity_nearby"
                name="activity_nearby"
                value={formData.activity_nearby || ''}
                onChange={handleChange}
                className={`form-input ${
                  validationActive && missingFields.includes("activity_nearby") ? "input-error" : ""
                }`}
                placeholder={texts.object.step5.activitiesPlaceholder}
              />
            </div>

            {/* Objektbeschreibung */}
            <div className="form-text-description">
              <h4 className="object-title">{texts.object.step5.descriptionTitle}</h4>
              <textarea
                id="description"
                name="description"
                value={formData.description === descriptionPlaceholder ? '' : formData.description}
                onChange={handleChange}
                onFocus={handleDescriptionFocus}
                onBlur={handleDescriptionBlur}
                className={`form-input ${
                  validationActive && missingFields.includes("description") ? "input-error" : ""
                }`}
                placeholder={descriptionPlaceholder}
                minLength="800"
                required
              />
            </div>

          </form>

        </div>
      </div>
    </div>
  );
};

export default CreateObjectStep5;
